// import { request } from "@/utils/request"
import { request } from "@/utils/request"

export function createOrder(data) {
    return request({
        url: "api/advertising/twitter/create",
        method: "post",
        data
        // data: {
        //     "link" : "https://twitter.com/status/1473794952719224836",
        //     "type" : "like",
        //     "object_id" : "1473794952719224836",
        //     "prices" : 1200,
        //     "quantity" : 10
        // }
    })
}
export function getListOrder(queries = "") {
    return request({
        url: "api/advertising/twitter" + queries,
        method: "get"
    })
}

export function removeOrder(data) {
    return request({
        url: "api/advertising/twitter/remove",
        method: "post",
        data
        // data: {
        //     "id" : 1
        // }
    })
}
